import AdvBanner from "../banners/AdvBanner";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { LOGO } from "../../utils/Constants";
import { useCountAllData } from "../../hooks/useCountAllData";
import { useState, useEffect } from "react";

const initialCount = 10;

const Category = () => {
  const { menuSubMenus, allDataCount } = useSelector((state) => state.menu);

  // Function to handle image error
  const handleImageError = (event) => {
    event.target.src = LOGO;
  };

  useCountAllData();

  const startTime = new Date("2025-04-28T00:00:00Z").getTime(); // fix any starting point

  const [orders, setOrders] = useState(0);

  const calculateCount = () => {
    const now = Date.now();
    const diffInMinutes = (now - startTime) / (1000 * 60);
    const blocksPassed = Math.floor(diffInMinutes / 15);

    console.log(initialCount, blocksPassed);

    return initialCount + blocksPassed * 2;
  };

  useEffect(() => {
    setOrders(calculateCount());

    const interval = setInterval(() => {
      setOrders(calculateCount());
    }, 60 * 1000); // check every minute if needed

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="feature" id="featureSection">
        <AdvBanner />
        {/*<div
          className="container container-lg gx-2"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            justifyContent: "center",
            marginBottom: "5px",
          }}>
          
          <div
            style={{
              minWidth: "180px",
              flex: "1",
              background: "white",
              padding: "5px",
              borderRadius: "8px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              borderLeft: "4px solid #3b82f6",
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}>
            <div
              style={{
                background: "#eff6ff",
                padding: "8px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#3b82f6">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                />
              </svg>
            </div>
            <div>
              <p
                style={{
                  color: "#6b7280",
                  fontSize: "14px",
                  margin: 0,
                  fontWeight: 700,
                }}>
                Registered Sellers
              </p>
              <p
                style={{
                  color: "#1f2937",
                  fontSize: "20px",
                  fontWeight: "bold",
                  margin: 0,
                }}>
                {allDataCount?.sellers}
              </p>
            </div>
          </div>

         
          <div
            style={{
              minWidth: "180px",
              flex: "1",
              background: "white",
              padding: "5px",
              borderRadius: "8px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              borderLeft: "4px solid #10b981",
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}>
            <div
              style={{
                background: "#ecfdf5",
                padding: "8px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#10b981">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                />
              </svg>
            </div>
            <div>
              <p
                style={{
                  color: "#6b7280",
                  fontSize: "14px",
                  margin: 0,
                  fontWeight: 700,
                }}>
                Registered Buyers
              </p>
              <p
                style={{
                  color: "#1f2937",
                  fontSize: "20px",
                  fontWeight: "bold",
                  margin: 0,
                }}>
                {allDataCount?.buyers}
              </p>
            </div>
          </div>

          
          <div
            style={{
              minWidth: "180px",
              flex: "1",
              background: "white",
              padding: "5px",
              borderRadius: "8px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              borderLeft: "4px solid #8b5cf6",
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}>
            <div
              style={{
                background: "#f5f3ff",
                padding: "8px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#8b5cf6">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                />
              </svg>
            </div>
            <div>
              <p
                style={{
                  color: "#6b7280",
                  fontSize: "14px",
                  margin: 0,
                  fontWeight: 700,
                }}>
                Listed Products
              </p>
              <p
                style={{
                  color: "#1f2937",
                  fontSize: "20px",
                  fontWeight: "bold",
                  margin: 0,
                }}>
                {allDataCount?.products}
              </p>
            </div>
          </div>

         
          <div
            style={{
              minWidth: "180px",
              flex: "1",
              background: "white",
              padding: "5px",
              borderRadius: "8px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              borderLeft: "4px solid #f97316",
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}>
            <div
              style={{
                background: "#ffedd5",
                padding: "8px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#f97316">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                />
              </svg>
            </div>
            <div>
              <p
                style={{
                  color: "#6b7280",
                  fontSize: "14px",
                  margin: 0,
                  fontWeight: 700,
                }}>
                Total Orders
              </p>
              <p
                style={{
                  color: "#1f2937",
                  fontSize: "20px",
                  fontWeight: "bold",
                  margin: 0,
                }}>
                {orders || 0}
              </p>
            </div>
          </div>
        </div>
        */}
        <div className="container container-lg gx-2">
          <div className="row gx-1 gy-1">
            {menuSubMenus.length > 0 &&
              menuSubMenus.map((item, index) => (
                <div
                  key={index}
                  className="col-12 col-sm-6 col-md-2 category-column">
                  <Link to={`/category/${item.slug_url}`}>
                    <div
                      key={index}
                      className="feature-item text-center"
                      data-aos-duration={index === 0 ? 200 : 200 * (index + 1)}>
                      <div className="px-8 py-16 border border-gray-100 hover-border-main-600 rounded-10 position-relative transition-2">
                        <div className="product-card__thumb flex-center">
                          <img
                            src={item.image || LOGO} // Fallback to LOGO if item.image is empty
                            alt={item.name}
                            onError={handleImageError} // Call handleImageError if image fails to load
                          />
                        </div>
                        <div className="product-card__content">
                          <h6 className="title text-md fw-semibold mt-12 mb-8 ">
                            <p className="link text-line-1">{item.name}</p>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Category;
